import { Context, CustomQuery } from '@vue-storefront/core';
import { UserShippingAddress, UserShippingAddressItem, ApiResult } from '../../types';

export default async function customShipping(context: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/address/list', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  if (res.code === 0) {
    const data = res.data;
    const allAddress: UserShippingAddress = {
      list: [],
      total: data.total_count,
      page: data.page,
      limit: data.limit
    };

    if (data && data.list) {
      // 循环list
      data.list.forEach((x) => {
        const address: UserShippingAddressItem = {
          firstName: x.first_name,
          addressId: x.address_id,
          lastName: x.last_name,
          streetName: x.street,
          apartment: x.apartment,
          city: x.city,
          state: x.state,
          zipCode: x.zip_code,
          country: x.country,
          phoneNumber: x.phone,
          sort: x.sort,
          isDefault: x.is_default
        };
        allAddress.list.push(address);
      });
    }
    res.data = allAddress;
  }

  return res;
}
